// config/auth.js - Fixed Authentication Configuration
const authConfig = {
  // Use the correct OIDC authority endpoint
  authority: process.env.REACT_APP_COGNITO_AUTHORITY ||
    `https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_JroDmdGrR`,

  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || "2qq5ghqsquifrg3vj12p2ktj4t",

  // Updated redirect URIs to default to localhost:3000
  redirect_uri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000",

  // Essential OIDC settings
  scope: "openid email profile",
  response_type: "code",

  // Remove problematic metadata URL - let the library auto-discover
  // metadataUrl: will be auto-discovered from authority

  // Proper OIDC settings
  automaticSilentRenew: false, // Disable for debugging
  loadUserInfo: true,

  // Remove problematic logout settings that might not be supported
  // revokeAccessTokenOnSignout: true,
  // includeIdTokenHint: true,

  // Remove extraQueryParams - these should be handled by Cognito configuration
  // extraQueryParams: {...}
};

export default authConfig;